<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar', 'Adimplencia')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormAdimplencia.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Nova Faixa de Adimplência
      </v-btn>
      <DialogFormAdimplencia @created="create($event)" ref="dialogFormAdimplencia" />
      <v-form ref="formBusca">
        <v-row dense>
          <v-col cols="12" sm="12" md="5">
            <SelectEmpresa
              :multiple="true"
              @onChanged="filtro.empresas = $event"
              @onEmpresas="empresas = $event"
              return-object
            />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-select label="Papel" v-model="filtro.papel" :items="['Vendedor', 'Supervisor']">
              <template v-slot:selection="{ item }">
                <v-chip>
                  <span>{{ item }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="d-flex align-center justify-center">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Adimplencia from "@/services/adimplencia";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FiltroAdimplencia",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogFormAdimplencia: () => import("./DialogFormAdimplencia.vue")
  },

  data() {
    return {
      serviceAdimplencia: new Adimplencia(),
      filtro: {
        empresas: []
      },
      empresas: []
    };
  },

  computed: {
    ...mapGetters("adimplencia", ["getAdimplencia"])
  },

  methods: {
    ...mapActions({
      actionAdimplencia: "adimplencia/actionAdimplencia"
    }),

    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          const dados = await this.serviceAdimplencia.getByEmpresaPapel(
            this.filtro,
            this.empresas
          );

          this.actionAdimplencia(dados);
          if (dados.length === 0) {
            this.$toast.warning("Nada foi encontrado");
          }
        } catch (error) {
          this.$toast.error(error);
        }
      }
    },

    create(adimplencia) {
      if (this.getAdimplencia === null) {
        this.actionAdimplencia([
          {
            id: adimplencia.id,
            empresa: adimplencia.empresa,
            dataCriacao: adimplencia.dataCriacao,
            apelido: adimplencia.apelido,
            faixaAdimplencia1: adimplencia.faixaAdimplencia1,
            faixaAdimplencia2: adimplencia.faixaAdimplencia2,
            papel: adimplencia.papel
          }
        ]);
      } else {
        this.actionAdimplencia(
          this.getAdimplencia.concat(
            ...[
              {
                id: adimplencia.id,
                empresa: adimplencia.empresa,
                dataCriacao: adimplencia.dataCriacao,
                apelido: adimplencia.apelido,
                faixaAdimplencia1: adimplencia.faixaAdimplencia1,
                faixaAdimplencia2: adimplencia.faixaAdimplencia2,
                papel: adimplencia.papel
              }
            ]
          )
        );
      }
    }
  },

  async mounted() {
    try {
      if (this.getAdimplencia.length === 0) {
        const response = await this.serviceAdimplencia.getAll();
        this.actionAdimplencia(response);
      }
    } catch (error) {
      this.$toast.error(`Erro ao buscar os dados`);
    }
  }
};
</script>

<style></style>
